import PrimaryButton from '../PrimaryButton/PrimaryButton';
import { Dialog, DialogContent } from '../Dialog';

interface Props {
  show: boolean;
  hideModal: () => void;
  title: string;
  message: string;
}

const DeleteArchiveErrorModal = ({ show, hideModal, title, message }: Props): JSX.Element => {
  return (
    <Dialog
      open={show}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          hideModal();
        }
      }}
    >
      <DialogContent
        className='w-[min(95vw,500px)] border-0 bg-transparent p-0 shadow-none'
        overlayClassName='bg-black/50'
      >
        <div className='overflow-hidden rounded-[15px] bg-white'>
          <div className='relative flex items-center justify-center bg-white px-[1.5rem] py-[1.5rem]'>
            <h2 className="m-0 max-w-[80%] text-center font-['GT-Walsheim-Pro-Regular'] text-[2.1rem] leading-[1.05] text-[#012a73]">
              {title}
            </h2>
            <button
              type='button'
              onClick={hideModal}
              aria-label='Close dialog'
              className='absolute right-[10px] top-[10px] cursor-pointer border-0 bg-transparent text-[2.4rem] leading-[2.4rem] text-[#012a73]'
            >
              x
            </button>
          </div>
          <div className='flex flex-col gap-[2em] px-[2em] pb-[2.5em] pt-[2.5em]'>
            <p className="m-0 flex flex-col font-['GT-Walsheim-Pro-Light'] text-[1.6rem] leading-[1.6] text-slate-800">
              {message}
            </p>
            <div className='flex justify-center'>
              <PrimaryButton type='button' onClick={hideModal} small>
                OK
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteArchiveErrorModal;
